import { Component, OnInit } from '@angular/core';
import { UserApiService } from '../user-api.service';
import { AutorizationService } from '../api/autorization.service';
import { Token } from '../models/api_models/token';
import { UserApi } from '../models/api_models/user';
import { ServiceInfo } from '../models/display/serviceInfo';

@Component({
  selector: 'app-login-home-page',
  templateUrl: './login-home-page.component.html',
  styleUrls: ['./login-home-page.component.scss']
})
export class LoginHomePageComponent implements OnInit {
  _servicesList : ServiceInfo[] = [];
  _currentUser : UserApi;
  isUserLoad : boolean = false;
  constructor(
    private userApiService : UserApiService,
    private autorizationService : AutorizationService) { }

  ngOnInit() {
    this.userApiService.getCurrentUserData().subscribe(
      response => {
        if (response != undefined) {
          this._currentUser = response;
          // console.log(this._currentUser);
          this.isUserLoad = true;
          this._servicesList = this._currentUser.getUserServices();
        }
      },
      error => {
        // console.log(error);
        
      }
    );
  }

}
